define(["./monitoringTemperatureOverviewModule"], function (module) {
    "use strict";

    return module.controller("monitoringTemperatureOverviewController", [
        "$scope",
        function ($scope) {
            $scope.currentDashboard =   {
                dashboardSourceId: ""
            };
        }]);
});
